import { render } from "./Links.vue?vue&type=template&id=347cf1ba"
import script from "./Links.vue?vue&type=script&lang=js"
export * from "./Links.vue?vue&type=script&lang=js"

import "./Links.vue?vue&type=style&index=0&id=347cf1ba&lang=css"
script.render = render

export default script